// One source of truth per record. Adding a photo is adding a filename here —
// the print on the page, the pile inside an opened record, and the light table
// all read from this. The first entry is the one used as the cover.
//
// Full-size originals live in photos-src/ and are not deployed; the copies in
// public/ are resized to 1500px for the web.
export const galleries = {
  about: ['kazuya.jpg'],
  research: ['research.jpg'],
  outside: ['monaco.jpg'],

  work_amazon: ['amazon.jpg'],
  work_eniaq: ['eniaq_office.jpg', 'eniaq.png'],
  work_osaro_sf: ['osaro_fanuc.jpg', 'osaro_3.jpg', 'osaro_4.jpg'],
  work_osaro_tokyo: ['osaro_1.jpg', 'osaro_2.jpg'],

  edu_master: ['master_1.png'],
  edu_trento: ['trento.jpg', 'trento_station.jpg', 'trento_1.jpg', 'trento_2.jpg'],
  edu_bachelor: ['bachelor_2.jpg', 'bachelor_1.jpg', 'bachelor_conf.jpg'],

  proj_cyclecount: ['drone_warehouse.jpg', 'xkura.jpg', 'xkura_experiment.jpg'],
  proj_naiso: ['naisoai.png'],
  proj_madoreader: ['madoreader.png'],
  proj_serving: ['serving.jpg'],
  proj_boat: ['boat.jpg'],
  proj_ardurover: ['ardurover.jpg'],
  proj_fpv: ['drone.jpg', 'film_drone.jpg'],
};

export const photosIn = (id) => galleries[id] || [];
